export type HighlightSegment = {
  text: string
  hl: boolean
}

export function highlightSearchSegments(
  text: string,
  queryTrimmed: string,
): HighlightSegment[] {
  const display = String(text ?? '')
  const q = String(queryTrimmed ?? '').trim()
  if (!q) {
    return [{ text: display, hl: false }]
  }
  const lower = display.toLowerCase()
  const qLower = q.toLowerCase()
  const qLen = q.length
  if (qLen === 0) {
    return [{ text: display, hl: false }]
  }
  const out: HighlightSegment[] = []
  let i = 0
  while (i < display.length) {
    const idx = lower.indexOf(qLower, i)
    if (idx === -1) {
      if (i < display.length) {
        out.push({ text: display.slice(i), hl: false })
      }
      break
    }
    if (idx > i) {
      out.push({ text: display.slice(i, idx), hl: false })
    }
    out.push({ text: display.slice(idx, idx + qLen), hl: true })
    i = idx + qLen
  }
  return out.length ? out : [{ text: display, hl: false }]
}

export function searchHighlightMarkClass(selected: boolean): string {
  return selected
    ? 'm-0 border-0 bg-transparent p-0 align-baseline font-inherit leading-inherit text-inherit shadow-none'
    : 'm-0 rounded-[1px] border-0 bg-amber-200/85 p-0 align-baseline font-inherit leading-inherit text-gray-900 shadow-[inset_0_0_0_1px_rgba(217,119,6,0.25)]'
}
